import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    isWithinFiscalYear: true,
};

export const detailsSlice = createSlice({
    name: 'details',
    initialState,
    reducers: {
        setIsWithinFiscalYear: (state, action) => {
            state.isWithinFiscalYear = action.payload;
        },
    },
});

export const { setIsWithinFiscalYear } = detailsSlice.actions;

export default detailsSlice.reducer;
